var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudSecure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 368,
    viewBox: "0 0 539 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.486 366.521C199.081 366.521 139.573 365.493 80.1653 364.553C59.8713 364.232 37.9812 364.888 18.2973 360.146C-3.59123 354.873 -7.74778 338.535 16.3288 330.408C26.4624 326.987 37.752 326.567 47.9375 323.256C49.5486 322.733 51.2281 322.065 52.101 320.82C53.8083 318.382 51.3707 315.191 48.2943 314.018C45.219 312.847 41.6885 312.922 38.4096 312.233C26.823 309.802 24.4191 296.078 31.7237 289.198C41.2996 280.176 55.6555 278.674 69.8987 278.674C73.4558 278.674 77.0061 278.767 80.4725 278.861C83.9404 278.955 87.3245 279.049 90.5495 279.049C90.7476 279.049 90.9464 279.048 91.1435 279.047C102.05 279.007 112.959 278.843 123.87 278.627C142.514 278.258 161.159 277.739 179.793 277.429C229.86 276.596 279.933 276 330.011 276C342.56 276 355.112 276.037 367.662 276.118C383.072 276.217 398.492 276.378 413.897 276.845L421.024 328.331L428.516 328.338L429.471 277.431C436.466 277.75 443.453 278.148 450.435 278.65C465.31 279.718 505.231 278.494 512.87 292.77C513.633 294.199 513.633 295.698 512.485 297.092C509.622 300.559 500.215 302.901 497.324 306.364C493.174 311.336 502.987 314.631 515.028 315.144C525.081 315.572 539.36 318.362 533.687 323.05C531.582 324.791 526.449 325.768 521.438 326.3C516.433 326.832 511.117 327.065 506.502 327.948C500.52 329.093 496.214 331.332 495.302 333.773C492.803 340.464 510.07 342.244 523.297 344.289C530.85 345.456 538.516 347.687 538.484 350.68C538.436 354.977 523.911 356.894 512.303 357.629C486.938 359.238 461.613 360.963 436.14 362.329C377.106 365.495 317.847 366.521 258.486 366.521Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3682 329.557L86.0012 334.018L94.216 339.898L94.0456 336.145L90.2924 330.975L82.077 325.095L81.3682 329.557Z",
    fill: "#3B455A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7566 192.652L86.6032 206.202L95.3394 267.789L81.1299 328.044L89.6994 331.221L121.979 260.446L124.773 238.409L123.538 192.367L88.7566 192.652Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.708 192.112L152.141 249.52L147.458 324.508L139.13 325.199L128.198 257.272L111.13 189.853L146.708 192.112Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.424 328.706L148.461 332.461L152.59 327.586L147.714 323.458L138.709 324.204L144.424 328.706Z",
    fill: "#3B455A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.7 127.609C103.264 128.529 100.827 129.449 98.3908 130.368C97.4463 128.519 96.6504 126.593 96.0125 124.617C93.7396 124.895 90.9975 124.982 89.6578 123.125C89.2358 122.54 89.0237 121.834 88.818 121.143C87.9692 118.286 87.1204 115.428 86.2715 112.57C85.9777 111.582 85.6818 110.562 85.7902 109.536C85.9809 107.738 87.3714 106.304 88.8314 105.235C92.5579 102.509 97.4383 101.193 101.921 102.297C103.115 102.591 104.298 103.069 105.183 103.922C106.546 105.237 106.992 107.213 107.374 109.068C107.726 110.781 108.079 112.494 108.432 114.206C108.837 116.176 109.158 118.485 107.802 119.971C107.082 120.759 105.978 121.179 105.425 122.093C104.45 123.704 105.69 125.726 105.7 127.609Z",
    fill: "#EAC5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.228 89.7062C116.303 88.8506 116.42 88.0024 116.608 87.1687C117.016 85.3623 117.757 83.6201 117.89 81.7731C118.022 79.9262 117.358 77.8405 115.696 77.0233C114.624 76.4956 113.356 76.5944 112.179 76.8006C108.301 77.4805 104.613 79.2222 101.624 81.786C98.777 84.2279 96.5419 87.0442 92.6557 87.4432C89.005 87.8187 87.0119 89.389 84.3607 92.1322C81.4916 95.1002 76.959 97.7098 74.6737 101.027C73.7196 102.412 73.2357 104.077 73.0433 105.748C72.3756 111.536 75.3532 117.588 80.3463 120.592C81.467 121.266 82.6695 121.793 83.8901 122.261C86.4174 123.229 89.474 124.458 92.0627 123.999C91.1151 121.95 86.1129 116.484 86.8458 114.057C88.0082 110.205 94.0376 108.362 97.4175 107.496C101.104 106.55 105.248 107.441 108.806 106.307C111.366 105.492 113.825 102.821 115.24 100.589C116.985 97.8332 115.956 92.8292 116.228 89.7062Z",
    fill: "#3B455A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2741 222.234C78.7725 227.472 79.7618 234.495 81.8003 234.517C82.1823 234.521 82.5209 234.293 82.8286 234.075C86.0781 231.773 88.2213 228.818 91.4286 226.585C94.7903 224.247 98.7737 222.746 102.714 221.56C108.602 219.756 114.672 218.353 120.79 217.528C127.433 216.632 140.545 216.422 140.545 216.422C144.213 215.355 147.636 213.647 151.08 212.032C156.997 209.257 163.073 206.711 168.514 203.158C170.259 202.018 175.054 198.692 172.937 196.438C171.334 194.732 166.488 194.031 164.234 193.132C156.894 190.202 150.325 185.869 145.604 179.415C139.141 170.577 134.486 159.033 130.933 148.707C130.275 146.794 129.668 144.864 129.084 142.929C128.752 141.83 128.257 137.583 127.354 136.974C118.194 130.801 115.012 124.824 105.118 127.565C82.5444 133.818 84.2939 134.647 80.4851 146.512C78.9531 151.283 77.5829 163.772 77.3649 168.734C77.101 174.743 76.9002 190.815 76.9074 196.827C76.9157 203.535 77.1683 210.245 77.8377 216.917C77.9125 217.658 78.038 219.745 78.2741 222.234Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.279 51.2861C354.701 30.0393 323.592 25.1506 299.506 38.6603L299.368 38.7196C292.152 43.6751 286.931 51.2108 286.305 61.2958C286.167 63.5113 282.887 63.3559 283.026 61.1238C283.697 50.3151 289.012 42.1245 296.5 36.6072C280.177 8.29418 247.356 -6.7137 217.484 2.91145C188.088 12.3838 169.482 42.351 171.045 74.7559C173.713 74.7938 176.393 75.0875 179.064 75.6793C189.684 78.0342 198.965 84.2373 206.488 92.5181C207.975 94.1552 205.63 96.509 204.147 94.8767C201.671 92.1517 198.956 89.6665 196.03 87.5013C185.169 79.4645 171.632 76.3544 159.002 79.9922C146.24 83.6685 134.068 94.3036 127.757 106.398C120.526 120.259 118.841 137.082 123.881 152.432C128.83 167.497 139.748 180.048 153.596 186.523C166.44 192.529 179.94 193.441 193.432 190.81C202.279 189.086 211.082 187.136 219.881 185.182C245.03 179.595 270.122 173.75 295.204 167.871C306.223 165.288 317.24 162.692 328.253 160.086C337.301 157.946 347.003 156.456 355.481 152.514C383.207 139.624 398.528 105.969 388.031 74.625C385.12 65.9324 380.397 57.9261 374.279 51.2861Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.045 192.355C177.441 192.355 173.861 192.094 170.321 191.545C173.359 191.99 176.416 192.204 179.485 192.204C184.117 192.204 188.774 191.718 193.432 190.81C202.279 189.085 211.082 187.135 219.881 185.181C245.03 179.594 270.122 173.75 295.204 167.87C306.161 165.302 317.116 162.721 328.068 160.13L328.037 160.427C319.717 162.419 311.394 164.405 303.071 166.385C299.984 167.12 296.897 167.85 293.811 168.583C269.193 174.353 244.564 180.085 219.881 185.568C211.082 187.523 202.279 189.472 193.432 191.197C191.813 191.512 190.195 191.776 188.577 191.986C186.057 192.229 183.545 192.355 181.045 192.355Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.485 192.204C176.416 192.204 173.359 191.991 170.321 191.545C166.339 190.929 162.406 189.949 158.54 188.571C158.642 188.463 158.707 188.287 158.844 188.263C175.586 185.324 188.506 183.073 202.052 179.652C244.337 169.012 288.909 157.501 329.874 142.577L328.068 160.13C317.116 162.721 306.161 165.302 295.204 167.87C270.122 173.75 245.03 179.595 219.881 185.181C211.082 187.136 202.279 189.086 193.432 190.81C188.774 191.718 184.117 192.204 179.485 192.204Z",
    fill: "url(#paint4_linear)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.276 126.632L383.073 126.611C388.355 117.178 391.32 106.34 391.354 95.1582C391.388 106.334 388.492 117.175 383.276 126.632Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.073 126.611L362.683 124.514C366.417 121.783 370.05 118.911 373.577 115.954C386.28 105.305 390.314 89.2299 387.475 73.4219C387.667 73.949 387.852 74.4789 388.031 75.0114C390.269 81.6963 391.334 88.4869 391.354 95.1579C391.32 106.339 388.355 117.178 383.073 126.611Z",
    fill: "url(#paint5_linear)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.246 326.037L465.669 330.245L458.019 335.483L453.561 331.791L457.174 327.068L464.824 321.83L465.246 326.037Z",
    fill: "#3B455A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.182 197.408L466.464 210.186L454.957 254.074L465.533 324.627L457.694 327.319L437.1 258.428L433.841 238.389L434.002 195.974L465.182 197.408Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.902 211.589L421.267 329.81L428.759 329.817L430.182 254.049L443.869 200.881L404.902 211.589Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.717 331.04L428.713 333.129L425.949 337.367L416.561 333.116L420.615 328.875L428.717 328.883V331.04Z",
    fill: "#3B455A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.643 125.157C429.297 120.486 442.917 123.188 450.084 123.195C451.561 138.92 454.429 154.625 457.942 170.007C460.977 183.3 466.777 196.261 469.35 209.534C471.646 221.373 476.665 229.886 486.11 238.003C487.582 239.267 489.277 240.909 488.836 242.799C488.571 243.939 487.58 244.747 486.614 245.408C477.076 251.934 464.824 252.602 453.268 252.786C444.493 252.926 435.717 252.912 426.942 252.745C415.512 252.527 402.795 251.17 393.055 244.549C392.441 244.131 391.784 243.592 391.738 242.85C391.699 242.213 392.125 241.656 392.5 241.14C399.317 231.742 398.544 216.186 399.882 205.176C401.392 192.75 402.908 180.289 405.887 168.131C407.82 160.244 410.366 152.509 413.493 145.015C415.872 139.31 418.714 129.964 423.178 125.575C423.326 125.43 423.481 125.29 423.643 125.157Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.254 73.9575C414.012 68.5032 409.238 64.2859 403.447 61.7622C399.529 60.0541 395.447 59.6343 391.499 59.2289L380.012 58.0475C374.674 57.4979 369.875 58.0267 365.344 59.6626C359.566 61.7483 354.289 66.0377 350.867 71.4296C348.387 75.3382 346.879 79.752 346.385 84.5494L340.14 145.253L349.268 146.192L355.544 85.1871C355.789 82.8034 356.22 81.2021 357.249 78.8408C358.048 77.0099 359.806 74.4425 361.253 72.9966C363.181 71.0701 364.92 69.8668 367.454 68.7051C369.764 67.647 372.003 67.1156 374.943 66.9292C375.067 66.9212 375.463 66.9067 376.452 66.9436C376.865 66.9585 377.308 66.9922 377.848 67.0472L393.929 68.7013C396.36 68.9513 397.979 69.3829 400.34 70.4121C402.173 71.2111 404.74 72.9694 406.186 74.4152C408.113 76.3433 409.316 78.0813 410.478 80.6162C411.536 82.9252 412.068 85.1641 412.254 88.1033C412.262 88.2283 412.276 88.6241 412.24 89.6122C412.224 90.025 412.192 90.4635 412.138 90.9912L405.861 152.011L414.988 152.95L421.264 91.9452C421.909 85.6753 420.523 79.455 417.254 73.9575Z",
    fill: "#F3E4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.487 168.899L375.848 184.836C375.726 186.02 374.248 186.838 372.546 186.663L372.484 186.657C370.782 186.481 369.501 185.38 369.623 184.196L371.262 168.259C366.134 166.34 362.739 161.148 363.325 155.448C364.022 148.672 370.081 143.744 376.858 144.441C383.634 145.138 388.563 151.196 387.866 157.972C387.28 163.672 382.898 168.063 377.487 168.899ZM332.056 121.365L325.247 187.553C324.326 196.505 330.837 204.508 339.791 205.429L400.732 211.696C409.685 212.617 417.69 206.107 418.611 197.155L425.42 130.966L332.056 121.365Z",
    fill: "#F3E4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.92 122.481L159.457 115.721L162.984 113.082L164.157 113.964L162.98 116.606L167.976 112.5L170.323 114.851L167.379 122.482L161.236 126.459L156.92 122.481Z",
    fill: "#EAC5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5541 135.452L134.418 146.776L155.225 120.817L163.731 128.564L142.276 162.844L94.0346 160.963C88.4705 160.746 83.644 157.053 81.9794 151.739C81.0328 148.718 81.2064 145.457 82.4683 142.553L85.5541 135.452Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.809 128.562L417.567 152.802L395.91 139.238L391.259 146.199L416.778 168.665L452.01 151.288L452.809 128.562Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.383 105.465C435.776 106.131 432.101 108.03 431.042 112.561C428.888 109.991 428.078 106.355 428.936 103.115C429.793 99.8737 432.297 97.1139 435.439 95.9453C438.019 97.7533 439.838 100.612 440.384 103.716L440.383 105.465Z",
    fill: "#3B455A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.394 126.544C432.007 124.946 429.855 121.36 429.239 117.666C428.625 113.972 429.358 110.176 430.503 106.61C434.314 94.7453 449.237 98.7303 452.371 109.111C455.101 118.157 445.244 131.19 435.394 126.544Z",
    fill: "#EAC5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.461 209.482C437.307 207.842 437.56 204.621 437.006 201.972C436.451 199.323 433.115 196.685 431.352 198.739C427.61 197.196 425.645 192.861 425.661 188.814C425.678 184.767 427.275 180.914 428.845 177.184C432.327 168.918 435.584 160.512 439.303 152.352C442.819 144.638 444.22 136.147 445.641 127.932C446.354 123.816 445.381 119.551 443.654 115.747C441.926 111.943 439.473 108.523 437.062 105.11C436.06 103.691 435.027 102.178 434.883 100.446C434.722 98.532 435.713 96.6541 437.125 95.3498C439.298 93.3437 441.685 92.5073 444.554 92.7941C454.627 93.8014 461.438 100.679 463.069 110.837C464.448 119.426 462.218 128.122 460.609 136.671C458.191 149.526 458.988 164.832 465.261 176.454C467.817 181.189 470.658 185.976 471.273 191.321C471.888 196.668 469.546 202.806 464.496 204.667C462.523 205.395 460.283 205.433 458.504 206.555C456.636 207.733 456.211 210.103 457.558 211.778C454.891 215.323 452.796 212.239 450.115 211.165C446.844 209.856 442.216 211.581 439.461 209.482Z",
    fill: "#3B455A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.866 140.8L393.203 136.528L385.466 134.973L384.301 138.067L389.715 142.715L392.929 143.701L394.866 140.8Z",
    fill: "#EAC5B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 81.1344,
    y1: 261.794,
    x2: 124.793,
    y2: 261.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 111.134,
    y1: 257.526,
    x2: 152.16,
    y2: 257.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 50.8679,
    y1: 206.507,
    x2: 116.986,
    y2: 155.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D66D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 311.126,
    y1: -30.32,
    x2: 270.668,
    y2: 153.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B18D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 279.034,
    y1: 134.749,
    x2: 274.607,
    y2: 184.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B18D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 382.846,
    y1: 65.0314,
    x2: 359.797,
    y2: 105.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B18D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 433.844,
    y1: 261.647,
    x2: 466.479,
    y2: 261.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 404.906,
    y1: 265.349,
    x2: 443.887,
    y2: 265.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 365.531,
    y1: 218.93,
    x2: 440.899,
    y2: 170.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D66D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 58.07,
    y1: 151.907,
    x2: 81.2337,
    y2: 112.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D66D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 374.661,
    y1: 158.229,
    x2: 399.071,
    y2: 125.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D66D3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 539,
    height: 368,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSecure);
export default __webpack_public_path__ + "static/media/cloud-secure.7f3a6d1c09119f78b311d5e074021629.svg";
export { ForwardRef as ReactComponent };